/**
 * Subscription plans (catalog) – React Query hook.
 */
import { useMemo, useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchSubscriptionPlans, type SubscriptionPlanCategory } from './plansApi';

export const subscriptionPlansQueryKey = ['subscription_plans'] as const;

const STALE_MS = 1000 * 60 * 5;

export function useSubscriptionPlans() {
  const query = useQuery({
    queryKey: subscriptionPlansQueryKey,
    queryFn: () => fetchSubscriptionPlans(),
    staleTime: STALE_MS,
  });

  const data = useMemo((): SubscriptionPlanCategory[] => (query.data ?? []) as SubscriptionPlanCategory[], [query.data]);
  const error = useMemo(() => (query.error instanceof Error ? query.error : null), [query.error]);
  const refetch = useCallback(() => query.refetch(), [query]);

  return useMemo(
    () => ({
      data,
      isLoading: query.isLoading,
      error,
      refetch,
    }),
    [data, query.isLoading, error, refetch],
  );
}
